/* eslint-disable no-console */
/* eslint-disable no-undef */
import { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';

import { Button } from '@/ui/index';
import { OutlineLocation } from '@/icons/index';

import Filters from '../Filters/Filters';
import Maps from '../Map/Map';

import styles from './OfficesList.module.scss';

const Shop = ({
  data,
  setTab = () => null,
  getCustomerLocation = () => null,
}) => {
  const { t } = useTranslation();

  const setLink = () => {
    setTab('map');
    getCustomerLocation(data);
  };
  return (
    <div
      className={`${styles.item} grid-extend`}
      itemScope
      itemType='https://schema.org/Offer'
    >
      {!!data && (
        <div className={styles.col}>
          <div className={styles.label}>{data?.type_name_of_office}</div>
          <div className={`${styles.value} grid-extend`}>
            <div className={styles.title}>{data?.name}</div>
            <div>{data?.description}</div>
          </div>
        </div>
      )}

      <div className={styles.col}>
        {data?.working_hours?.length > 0 && (
          <>
            <div className={styles.label}>{t('common:workingHours')}</div>
            <div className={`${styles.value} grid-extend`}>
              {data?.working_hours?.map((item, index) => (
                <div className={`${styles.hours} grid-extend`} key={index}>
                  <span>
                    {item?.days}
                    {item?.working_hours && ':'}
                  </span>
                  <span>{item?.working_hours}</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      <div className={styles.col}>
        {data?.email && (
          <>
            <div className={styles.label}>{t('common:email')}</div>
            <div className={`${styles.value} grid-extend`}>
              <div>{data.email}</div>
            </div>
          </>
        )}
      </div>

      <div className={styles.col}>
        {data?.phone_number && (
          <>
            <div className={styles.label}>{t('common:phone')}</div>
            <div className={`${styles.value} grid-extend`}>
              <div>{data?.phone_number}</div>
            </div>
          </>
        )}
      </div>

      <div className={styles.col}>
        {data?.lat && data?.lng && (
          <Button onClick={setLink} className={`${styles.link} flex-c-c`}>
            <OutlineLocation />
          </Button>
        )}
      </div>
    </div>
  );
};

const OfficesList = ({ data }) => {
  const [tab, setTab] = useState('map');
  const [offices, setOffices] = useState(data?.our_offices ?? []);
  const [customerLocation, setCustomerLocation] = useState(null);

  const getCustomerLocation = (location) => {
    setCustomerLocation({
      lat: location?.lat,
      lng: location?.lng,
    });
  };

  const onFilterChange = ({ city, officeType }) => {
    const filtered = (data?.our_offices ?? []).filter((office) => {
      const matchesCity =
        city?.value === 'all' ||
        String(office?.city_id) === String(city?.value);
      const matchesOfficeType =
        officeType?.value === 0 ||
        String(office?.office_type.id) === String(officeType?.value);
      return matchesCity && matchesOfficeType;
    });

    setOffices(filtered);
  };

  return (
    !!data && (
      <div
        className={styles.wrap}
        itemScope
        itemType='https://schema.org/ItemList'
      >
        <Filters
          cities={data?.cities}
          offices={data?.office_types}
          tab={tab}
          setTab={setTab}
          className={classNames({
            [styles.filterWrap]: tab === 'list',
            [styles.filterWrapMap]: tab === 'map',
          })}
          onFilterChange={onFilterChange}
        />

        {tab === 'map' && (
          <div>
            <Maps markers={offices} customerLocation={customerLocation} />
          </div>
        )}

        {tab === 'list' && (
          <div>
            <div className={`${styles.listWrap} wrapper section`}>
              <div className={styles.list}>
                {offices?.map((item, index) => (
                  <Shop
                    key={index}
                    data={item}
                    setTab={setTab}
                    getCustomerLocation={getCustomerLocation}
                  />
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

export default OfficesList;
